export const filteredDomains = [
  ".xyz",
  ".shop",
  ".online",
  ".top",
  ".site",
  ".store",
  ".vip",
  ".sbs",
  ".bond",
  ".app",
  ".lol",
  ".club",
  ".live",
  ".fun",
  ".today",
  ".icu",
  ".tech",
  ".click",
  ".dev",
  ".cfd",
  ".life",
  ".cloud",
  ".buzz",
  ".space",
  ".blog",
  ".cyou",
  ".world",
  ".website",
  ".art",
  ".one",
  ".work",
  ".link",
  ".group",
  ".tokyo",
  ".lat",
  ".digital",
  ".ltd",
  ".agency",
  ".studio",
  ".email",
  ".design",
  ".solutions",
  ".rest",
  ".win",
  ".skin",
  ".services",
  ".bet",
  ".homes",
  ".网址 (xn--ses554g)",
  ".media",
  ".fyi",
  ".network",
  ".pics",
  ".autos",
  ".ink",
  ".company",
  ".wiki",
  ".best",
  ".ovh",
  ".news",
  ".zone",
  ".love",
  ".academy",
  ".wang",
  ".cam",
  ".rocks",
  ".nyc",
  ".monster",
  ".mom",
  ".bio",
  ".global",
  ".guru",
  ".team",
  ".africa",
  ".games",
  ".quest",
  ".page",
  ".berlin",
  ".social",
  ".loan",
  ".llc",
  ".在线 (xn--3ds443g)",
  ".med",
  ".care",
  ".bid",
  ".beauty",
  ".ooo",
  ".makeup",
  ".chat",
  ".boats",
  ".center",
  ".support",
  ".fit",
  ".business",
  ".health",
  ".wtf",
  ".earth",
  ".photography",
  ".consulting",
  ".systems",
  ".foundation",
  ".help",
  ".finance",
  ".events",
  ".london",
  ".realtor",
  ".family",
  ".plus",
  ".商城 (xn--czru2d)",
  ".technology",
  ".church",
  ".run",
  ".city",
  ".gmbh",
  ".expert",
  ".education",
  ".works",
  ".marketing",
  ".photo",
  ".capital",
  ".bayern",
  ".motorcycles",
  ".pink",
  ".baby",
  ".ninja",
  ".商标 (xn--czr694b)",
  ".international",
  ".coach",
  ".coffee",
  ".farm",
  ".christmas",
  ".hair",
  ".公司 (xn--55qx5d)",
  ".community",
  ".photos",
  ".house",
  ".tools",
  ".cool",
  ".college",
  ".host",
  ".手机 (xn--kput3i)",
  ".casino",
  ".party",
  ".cafe",
  ".rent",
  ".software",
  ".energy",
  ".ing",
  ".pictures",
  ".school",
  ".swiss",
  ".rip",
  ".training",
  ".video",
  ".pet",
  ".land",
  ".tips",
  ".legal",
  ".ventures",
  ".pub",
  ".nrw",
  ".uno",
  ".law",
  ".fund",
  ".bar",
  ".market",
  ".рус (xn--p1acf)",
  ".amsterdam",
  ".red",
  ".immo",
  ".paris",
  ".trade",
  ".gay",
  ".gallery",
  ".money",
  ".guide",
  ".hamburg",
  ".koeln",
  ".band",
  ".cash",
  ".show",
  ".wine",
  ".pizza",
  ".dog",
  ".wedding",
  ".网络 (xn--io0a7i)",
  ".casa",
  ".exchange",
  ".press",
  ".yoga",
  ".directory",
  ".realestate",
  ".miami",
  ".institute",
  ".blue",
  ".bot",
  ".yachts",
  ".codes",
  ".bike",
  ".wien",
  ".men",
  ".moscow",
  ".eus",
  ".moe",
  ".golf",
  ".loans",
  ".clinic",
  ".partners",
  ".feedback",
  ".properties",
  ".beer",
  ".zip",
  ".boutique",
  ".fashion",
  ".xin",
  ".gold",
  ".rentals",
  ".scot",
  ".stream",
  ".wales",
  ".gdn",
  ".fitness",
  ".bzh",
  ".management",
  ".sale",
  ".中文网 (xn--fiq228c5hs)",
  ".tours",
  ".tax",
  ".direct",
  ".reviews",
  ".vision",
  ".contact",
  ".style",
  ".我爱你 (xn--6qq986b3xl)",
  ".vet",
  ".science",
  ".vegas",
  ".auction",
  ".day",
  ".estate",
  ".clothing",
  ".kiwi",
  ".jetzt",
  ".productions",
  ".solar",
  ".report",
  ".МОСКВА (xn--80adxhks)",
  ".frl",
  ".onl",
  ".engineering",
  ".cards",
  ".careers",
  ".express",
  ".watch",
  ".vin",
  ".healthcare",
  ".construction",
  ".place",
  ".ren",
  ".sport",
  ".fan",
  ".green",
  ".sexy",
  ".eco",
  ".dental",
  ".kim",
  ".deals",
  ".delivery",
  ".army",
  ".shopping",
  ".lawyer",
  ".holdings",
  ".restaurant",
  ".fans",
  ".computer",
  ".university",
  ".enterprises",
  ".cymru",
  ".brussels",
  ".dance",
  ".haus",
  ".sucks",
  ".tirol",
  ".date",
  ".download",
  ".camp",
  ".porn",
  ".supply",
  ".financial",
  ".meme",
  ".repair",
  ".kitchen",
  ".domains",
  ".parts",
  ".ist",
  ".quebec",
  ".review",
  ".gives",
  ".srl",
  ".sydney",
  ".gal",
  ".limited",
  ".industries",
  ".immobilien",
  ".build",
  ".lgbt",
  ".investments",
  ".black",
  ".town",
  ".sex",
  ".dvag",
  ".cpa",
  ".taxi",
  ".engineer",
  ".melbourne",
  ".promo",
  ".vote",
  ".film",
  ".adult",
  ".game",
  ".charity",
  ".gift",
  ".ceo",
  ".lighting",
  ".menu",
  ".credit",
  ".ski",
  ".graphics",
  ".builders",
  ".insure",
  ".football",
  ".now",
  ".fish",
  ".vlaanderen",
  ".ngo",
  ".doctor",
  ".istanbul",
  ".music",
  ".kaufen",
  ".inc",
  ".网店 (xn--hxt814e)",
  ".toys",
  ".schule",
  ".claims",
  ".trading",
  ".poker",
  ".gifts",
  ".kids",
  ".boston",
  ".移动 (xn--6frz82g)",
  ".attorney",
  ".audio",
  ".barcelona",
  ".faith",
  ".garden",
  ".equipment",
  ".mba",
  ".ruhr",
  ".forsale",
  ".surf",
  ".mortgage",
  ".닷컴 (xn--mk1bu44c)",
  ".capetown",
  ".okinawa",
  ".cologne",
  ".movie",
  ".food",
  ".tube",
  ".apartments",
  ".reisen",
  ".mov",
  ".country",
  ".racing",
  ".forum",
  ".shoes",
  ".fail",
  ".salon",
  ".taipei",
  ".recipes",
  ".markets",
  ".vacations",
  ".associates",
  ".holiday",
  ".cheap",
  ".jewelry",
  ".box",
  ".cab",
  ".saarland",
  ".ong",
  ".courses",
  ".luxe",
  ".nagoya",
  ".dating",
  ".contractors",
  ".irish",
  ".study",
  ".glass",
  ".archi",
  ".how",
  ".gratis",
  ".soccer",
  ".luxury",
  ".yokohama",
  ".camera",
  ".gent",
  ".madrid",
  ".catering",
  ".boo",
  ".horse",
  ".coupons",
  ".discount",
  ".rodeo",
  ".supplies",
  ".property",
  ".actor",
  ".singles",
  ".exposed",
  ".集团 (xn--3bst00m)",
  ".radio",
  ".foo",
  ".tattoo",
  ".rsvp",
  ".dentist",
  ".giving",
  ".plumbing",
  ".cleaning",
  ".企业 (xn--vhquv)",
  ".joburg",
  ".voyage",
  ".broker",
  ".furniture",
  ".dad",
  ".bank",
  ".닷넷 (xn--t60b56a)",
  ".コム (xn--tckwe)",
  ".webcam",
  ".moda",
  ".hosting",
  ".信息 (xn--vuq861b)",
  ".futbol",
  ".САЙТ (xn--80aswg)",
  ".alsace",
  ".corsica",
  ".bingo",
  ".ОНЛАЙН (xn--80asehdb)",
  ".observer",
  ".cooking",
  ".tienda",
  ".durban",
  ".rehab",
  ".esq",
  ".diamonds",
  ".购物 (xn--g2xx48c)",
  ".cruises",
  ".florist",
  ".nexus",
  ".flights",
  ".bargains",
  ".limo",
  ".hospital",
  ".villas",
  ".lease",
  ".hockey",
  ".phd",
  ".tennis",
  ".みんな (xn--q9jyb4c)",
  ".diy",
  ".accountants",
  ".fishing",
  ".desi",
  ".degree",
  ".soy",
  ".krd",
  ".surgery",
  ".vodka",
  ".audi",
  ".organic",
  ".condos",
  ".new",
  ".kred",
  ".lifestyle",
  ".spa",
  ".mma",
  ".accountant",
  ".网站 (xn--5tzm5g)",
  ".theater",
  ".living",
  ".versicherung",
  ".allfinanz",
  ".hiphop",
  ".navy",
  ".career",
  ".tickets",
  ".maison",
  ".gop",
  ".creditcard",
  ".zuerich",
  ".商店 (xn--czrs0t)",
  ".bible",
  ".diet",
  ".realty",
  ".republican",
  ".קום (xn--9dbq2a)",
  ".sarl",
  ".democrat",
  ".leclerc",
  ".tires",
  ".tatar",
  ".cricket",
  ".forex",
  ".gripe",
  ".flowers",
  ".kyoto",
  ".reise",
  ".physio",
  ".osaka",
  ".abudhabi",
  ".blackfriday",
  ".locker",
  ".whoswho",
  ".airforce",
  ".ОРГ (xn--c1avg)",
  ".memorial",
  ".дети (xn--d1acj3b)",
  ".viajes",
  ".广东 (xn--xhq521b)",
  ".seat",
  ".prof",
  ".reit",
  ".basketball",
  ".ryukyu",
  ".pharmacy",
  ".rio",
  ".deal",
  ".shiksha",
  ".neustar",
  ".guitars",
  ".security",
  ".select",
  ".compare",
  ".voto",
  ".abogado",
  ".ltda",
  ".storage",
  ".rugby",
  ".世界 (xn--rhqv96g)",
  ".crs",
  ".بازار (xn--mgbab2bd)",
  ".qpon",
  ".juegos",
  ".auto",
  ".schwarz",
  ".gmx",
  ".游戏 (xn--unup4y)",
  ".شبكة (xn--ngbc5azd)",
  ".moi",
  ".creditunion",
  ".娱乐 (xn--fjq720a)",
  ".abbott",
  ".goog",
  ".机构 (xn--nqv7f)",
  ".aco",
  ".broadway",
  ".car",
  ".watches",
  ".cars",
  ".channel",
  ".bnpparibas",
  ".lundbeck",
  ".fox",
  ".lamborghini",
  ".佛山 (xn--1qqw23a)",
  ".bradesco",
  ".google",
  ".hiv",
  ".stockholm",
  ".mini",
  ".man",
  ".insurance",
  ".weir",
  ".globo",
  ".संगठन (xn--i1b6b1a6a2e)",
  ".weber",
  ".citic",
  ".ストア (xn--cck2b3b)",
  ".dealer",
  ".toyota",
  ".theatre",
  ".barclays",
  ".bmw",
  ".jnj",
  ".nra",
  ".lipsy",
  ".aws",
  ".amazon",
  ".sky",
  ".stada",
  ".sbi",
  ".afl",
  ".セール (xn--1ck2e1b)",
  ".lotto",
  ".auspost",
  ".erni",
  ".rich",
  ".protection",
  ".total",
  ".edeka",
  ".موقع (xn--4gbrim)",
  ".餐厅 (xn--imr513n)",
  ".yandex",
  ".target",
  ".discover",
  ".saxo",
  ".中信 (xn--fiq64b)",
  ".teva",
  ".microsoft",
  ".azure",
  ".cern",
  ".クラウド (xn--gckr3f0f)",
  ".tui",
  ".toray",
  ".deloitte",
  ".cba",
  ".dhl",
  ".komatsu",
  ".kfh",
  ".bloomberg",
  ".monash",
  ".voting",
  ".家電 (xn--fct429k)",
  ".pru",
  ".canon",
  ".ifm",
  ".pfizer",
  ".lidl",
  ".axa",
  ".chase",
  ".jpmorgan",
  ".prudential",
  ".sncf",
  ".fage",
  ".bridgestone",
  ".政务 (xn--zfr164b)",
  ".ファッション (xn--bck1b9a5dre4c)",
  ".ابوظبي (xn--mgbca7dzdo)",
  ".uol",
  ".shell",
  ".招聘 (xn--otu796d)",
  ".trust",
  ".aig",
  ".食品 (xn--jvr189m)",
  ".ricoh",
  ".meet",
  ".mango",
  ".smart",
  ".aquarelle",
  ".firmdale",
  ".airbus",
  ".vana",
  ".apple",
  ".philips",
  ".fresenius",
  ".公益 (xn--55qw42g)",
  ".pictet",
  ".mlb",
  ".case",
  ".statefarm",
  ".scb",
  ".anz",
  ".八卦 (xn--45q11c)",
  ".kpn",
  ".ipiranga",
  ".statebank",
  ".vivo",
  ".書籍 (xn--rovu88b)",
  ".bostik",
  ".abbvie",
  ".godaddy",
  ".xbox",
  ".sandvik",
  ".wed",
  ".itau",
  ".schmidt",
  ".vig",
  ".cisco",
  ".itv",
  ".bauhaus",
  ".sap",
  ".ismaili",
  ".sener",
  ".gmo",
  ".abb",
  ".sandvikcoromant",
  ".dell",
  ".clubmed",
  ".barclaycard",
  ".ikano",
  ".schaeffler",
  ".hisamitsu",
  ".latrobe",
  ".bentley",
  ".بيتك (xn--ngbe9e0a)",
  ".sew",
  ".pioneer",
  ".jio",
  ".walter",
  ".williamhill",
  ".bing",
  ".ally",
  ".健康 (xn--nyqy26a)",
  ".woodside",
  ".windows",
  ".hyatt",
  ".locus",
  ".allstate",
  ".lanxess",
  ".hotmail",
  ".sharp",
  ".redstone",
  ".abc",
  ".praxi",
  ".sanofi",
  ".youtube",
  ".gle",
  ".gea",
  ".hitachi",
  ".jcb",
  ".suzuki",
  ".tatamotors",
  ".kpmg",
  ".marriott",
  ".next",
  ".ford",
  ".ntt",
  ".catholic",
  ".gucci",
  ".otsuka",
  ".vanguard",
  ".extraspace",
  ".bbva",
  ".nhk",
  ".hsbc",
  ".cuisinella",
  ".arte",
  ".seven",
  ".hyundai",
  ".politie",
  ".dubai",
  ".jll",
  ".helsinki",
  ".nico",
  ".emerck",
  ".stc",
  ".brother",
  ".飞利浦 (xn--kcrx77d1x4a)",
  ".sony",
  ".temasek",
  ".nowruz",
  ".alstom",
  ".zappos",
  ".ice",
  ".nec",
  ".orange",
  ".lilly",
  ".lexus",
  ".amfam",
  ".swatch",
  ".wme",
  ".office",
  ".honda",
  ".aetna",
  ".skype",
  ".chintai",
  ".cfa",
  ".sfr",
  ".yodobashi",
  ".hermes",
  ".amex",
  ".dupont",
  ".lancaster",
  ".genting",
  ".maif",
  ".sohu",
  ".bbc",
  ".flickr",
  ".ieee",
  ".ferrero",
  ".aeg",
  ".mattel",
  ".rexroth",
  ".gmail",
  ".netbank",
  ".ericsson",
  ".cbn",
  ".frogans",
  ".fujitsu",
  ".mtn",
  ".toshiba",
  ".yahoo",
  ".chanel",
  ".nissan",
  ".grainger",
  ".java",
  ".nokia",
  ".jmp",
  ".able",
  ".omega",
  ".nike",
  ".rogers",
  ".citi",
  ".tvs",
  ".softbank",
  ".americanexpress",
  ".android",
  ".imamat",
  ".play",
  ".eurovision",
  ".jaguar",
  ".zara",
  ".samsung",
  ".landrover",
  ".commbank",
  ".fairwinds",
  ".crown",
  ".aaa",
  ".mtr",
  ".panasonic",
  ".akdn",
  ".unicom",
  ".oracle",
  ".lincoln",
  ".bcn",
  ".analytics",
  ".mit",
  ".aarp",
  ".here",
  ".ping",
  ".pwc",
  ".jprs",
  ".firestone",
  ".amica",
  ".nab",
  ".pohl",
  ".vermögensberatung (xn--vermgensberatung-pwb)",
  ".联通 (xn--8y0a063a)",
  ".travelers",
  ".prime",
  ".kia",
  ".prod",
  ".travelersinsurance",
  ".lego",
  ".sas",
  ".ups",
  ".ftr",
  ".hdfcbank",
  ".eat",
  ".trv",
  ".fly",
  ".goo",
  ".العليان (xn--mgba7c0bbn0a)",
  ".caravan",
  ".star",
  ".bms",
  ".olayangroup",
  ".ibm",
  ".epson",
  ".ubs",
  ".sakura",
  ".playstation",
  ".vermögensberater (xn--vermgensberater-ctb)",
  ".ads",
  ".anquan",
  ".dnp",
  ".beats",
  ".mitsubishi",
  ".nfl",
  ".virgin",
  ".infiniti",
  ".tab",
  ".bcg",
  ".olayan",
  ".chrome",
  ".docs",
  ".redumbrella",
  ".rwe",
  ".wtc",
  ".nextdirect",
  ".flir",
  ".volvo",
  ".obi",
  ".xerox",
  ".got",
  ".jot",
  ".zero",
  ".点看 (xn--3pxu8k)",
  ".ril",
  ".ollo",
  ".imdb",
  ".farmers",
  ".progressive",
  ".hbo",
  ".dish",
  ".secure",
  ".data",
  ".组织机构 (xn--nqv7fs00ema)",
  ".coupon",
  ".pccw",
  ".dtv",
  ".嘉里 (xn--w4rs40l)",
  ".ferrari",
  ".asda",
  ".intuit",
  ".hot",
  ".wow",
  ".map",
  ".bharti",
  ".tci",
  ".norton",
  ".room",
  ".like",
  ".agakhan",
  ".richardli",
  ".netflix",
  ".save",
  ".pay",
  ".cruise",
  ".phone",
  ".政府 (xn--mxtq1m)",
  ".新闻 (xn--efvy88h)",
  ".dclk",
  ".كوم (xn--fhbei)",
  ".spot",
  ".dot",
  ".msd",
  ".samsclub",
  ".visa",
  ".bestbuy",
  ".香格里拉 (xn--5su34j936bgsg)",
  ".search",
  ".慈善 (xn--30rr7y)",
  ".aramco",
  ".comsec",
  ".song",
  ".sina",
  ".reliance",
  ".nikon",
  ".fire",
  ".cbre",
  ".mckinsey",
  ".blockbuster",
  ".banamex",
  ".天主教 (xn--tiq49xqyj)",
  ".free",
  ".grocery",
  ".llp",
  ".gbiz",
  ".谷歌 (xn--flw351e)",
  ".accenture",
  ".ارامكو (xn--mgba3a3ejt)",
  ".circle",
  ".safety",
  ".icbc",
  ".tunes",
  ".thd",
  ".nowtv",
  ".barefoot",
  ".tkmaxx",
  ".americanfamily",
  ".lpl",
  ".juniper",
  ".fido",
  ".shangrila",
  ".كاثوليك (xn--mgbi4ecexp)",
  ".merckmsd",
  ".淡马锡 (xn--b4w605ferd)",
  ".时尚 (xn--9et52u)",
  ".goldpoint",
  ".call",
  ".yun",
  ".alipay",
  ".weatherchannel",
  ".lasalle",
  ".tdk",
  ".silk",
  ".winners",
  ".bofa",
  ".католик (xn--80aqecdr1a)",
  ".アマゾン (xn--cckwcxetd)",
  ".datsun",
  ".グーグル (xn--qcka1pmc)",
  ".guge",
  ".kddi",
  ".yamaxun",
  ".pid",
  ".delta",
  ".drive",
  ".mls",
  ".audible",
  ".open",
  ".fidelity",
  ".verisign",
  ".亚马逊 (xn--jlq480n2rg)",
  ".mormon",
  ".hangout",
  ".author",
  ".alibaba",
  ".homedepot",
  ".tjmaxx",
  ".tiaa",
  ".hughes",
  ".calvinklein",
  ".walmart",
  ".mint",
  ".dvr",
  ".pin",
  ".tushu",
  ".weather",
  ".taobao",
  ".gallup",
  ".viking",
  ".talk",
  ".嘉里大酒店 (xn--w4r85el8fhu5dnra)",
  ".gallo",
  ".kindle",
  ".dunlop",
  ".homegoods",
  ".pramerica",
  ".gap",
  ".baseball",
  ".ggee",
  ".همراه (xn--mgbt3dhd)",
  ".final",
  ".viva",
  ".seek",
  ".smile",
  ".xihuan",
  ".大拿 (xn--pssy2u)",
  ".tmall",
  ".cipriani",
  ".kerryproperties",
  ".kerryhotels",
  ".goodyear",
  ".tjx",
  ".george",
  ".lplfinancial",
  ".ubank",
  ".nissay",
  ".hotels",
  ".pars",
  ".stcgroup",
  ".lotte",
  ".ポイント (xn--eckvdtc9d)",
  ".fast",
  ".कॉम (xn--11b4c3d)",
  ".you",
  ".pnc",
  ".marshalls",
  ".nba",
  ".jeep",
  ".aol",
  ".cal",
  ".lds",
  ".buy",
  ".baidu",
  ".weibo",
  ".booking",
  ".bbt",
  ".sling",
  ".lamer",
  ".عرب (xn--ngbrx)",
  ".삼성 (xn--cg4bki)",
  ".scholarships",
  ".joy",
  ".safe",
  ".shouji",
  ".नेट (xn--c2br7g)",
  ".lifeinsurance",
  ".frontier",
  ".微博 (xn--9krt00a)",
  ".ott",
  ".bosch",
  ".homesense",
  ".citadel",
  ".latino",
  ".staples",
  ".capitalone",
  ".kosher",
  ".origins",
  ".arab",
  ".lacaixa",
  ".wanggou",
  ".คอม (xn--42c2d9a)",
  ".kuokgroup",
  ".電訊盈科 (xn--fzys8d69uvgm)",
  ".boehringer",
  ".lefrak",
  ".wolterskluwer",
  ".clinique",
  ".shia",
  ".bom",
  ".airtel",
  ".read",
  ".ком (xn--j1aef)",
  ".kerrylogistics",
  ".dds",
  ".hkt",
  ".moto",
  ".hdfc",
  ".athleta",
  ".fedex",
  ".book",
  ".通販 (xn--gk3at1e)",
  ".mobile",
];

export const temporaryMails = [
  "gongjua.com",
  "deepyinc.com",
  "maillazy.com",
  "inctart.com",
  "0-mail.com",
  "10minutemail.com",
  "20minutemail.com",
  "30minutemail.com",
  "anonbox.net",
  "binkmail.com",
  "disposableemailaddresses.com",
  "dropmail.me",
  "emailondeck.com",
  "fakeinbox.com",
  "getairmail.com",
  "guerrillamail.com",
  "maildrop.cc",
  "mailinator.com",
  "mohmal.com",
  "mytemp.email",
  "sharklasers.com",
  "spamgourmet.com",
  "temp-mail.org",
  "tempmail.plus",
  "tempr.email",
  "throwawaymail.com",
  "trashmail.com",
  "yopmail.com",
  "pokemail.net",
  "spam4.me",
  "grr.la",
];
